/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type teamRow_team$ref: FragmentReference;
declare export opaque type teamRow_team$fragmentType: teamRow_team$ref;
export type teamRow_team = {|
  +id: string,
  +rowId: any,
  +name: string,
  +avatar: ?string,
  +account: ?{|
    +members: {|
      +totalCount: number
    |}
  |},
  +bots: {|
    +totalCount: number
  |},
  +$refType: teamRow_team$ref,
|};
export type teamRow_team$data = teamRow_team;
export type teamRow_team$key = {
  +$data?: teamRow_team$data,
  +$fragmentRefs: teamRow_team$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "teamRow_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatar",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MembersConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BotsConnection",
      "kind": "LinkedField",
      "name": "bots",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Team"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b79e34eb776f7cdd067a1f775261d7db';

module.exports = node;
